var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import queryString from "query-string";
var arrayFormat = "comma";
var parse = queryString.parse, stringify = queryString.stringify;
export var UrlParamKeys;
(function (UrlParamKeys) {
    UrlParamKeys["Customer"] = "cu";
    UrlParamKeys["Driver"] = "dr";
    UrlParamKeys["EndDate"] = "ed";
    UrlParamKeys["JobSite"] = "js";
    UrlParamKeys["Location"] = "lo";
    UrlParamKeys["MessageType"] = "mt";
    UrlParamKeys["MixCode"] = "mc";
    UrlParamKeys["Order"] = "or";
    UrlParamKeys["Phase"] = "ph";
    UrlParamKeys["Plant"] = "pl";
    UrlParamKeys["Search"] = "s";
    UrlParamKeys["SortColumn"] = "sc";
    UrlParamKeys["SortDirection"] = "sdr";
    UrlParamKeys["Source"] = "so";
    UrlParamKeys["StartDate"] = "sd";
    UrlParamKeys["Status"] = "sta";
    UrlParamKeys["SubType"] = "st";
    UrlParamKeys["Ticket"] = "ti";
    UrlParamKeys["TrafficOn"] = "to";
    UrlParamKeys["Truck"] = "tr";
    UrlParamKeys["AccountId"] = "id";
})(UrlParamKeys || (UrlParamKeys = {}));
export var updateSearchString = function (search, newParams) {
    var otherParams = parse(search, { arrayFormat: arrayFormat });
    var queryParamString = stringify(__assign(__assign({}, otherParams), newParams), { arrayFormat: arrayFormat });
    return "?".concat(queryParamString);
};
export var updateHistory = function (history, newParams, url) {
    var search = history.location.search;
    var otherParams = parse(search, { arrayFormat: arrayFormat });
    replaceQueryParams(history, __assign(__assign({}, otherParams), newParams), url);
};
export var replaceQueryParams = function (_a, newParams, url) {
    var pathname = _a.location.pathname, replace = _a.replace;
    var queryParamString = stringify(newParams, { arrayFormat: arrayFormat });
    replace("".concat(url || pathname, "?").concat(queryParamString));
};
export var getParsedParams = function (location) {
    return parse(location.search, { arrayFormat: arrayFormat });
};
export var handleTrack = function (label, trackedValue) {
    window.analytics.track(label, {
        valueSelected: trackedValue,
    });
};
export var resetHistory = function (history) {
    return replaceQueryParams(history, {});
};
//# sourceMappingURL=historyUtil.js.map